import React from "react";
import "./MultipleAssignmentviewPopup.css";
import BackButton from "../BackButton/BackButton";
import MultipleAssignmentStaticContent from "./MultipleAssignmentStaticContent";
import PreprocessAndRenderLatex from "../ProcessRenderLatex";
import { AssignmentType } from "../../utils/consts";

function MultipleAssignmentviewPopup({ type, startAssignmentPopupHandler, startAssignmentHandler, rubric, assignment, index, courseType }) {

    const getAssignmentTypeName = (type) => {
        return Object.values(AssignmentType).find((item) => {
            return item.value === type;
        })?.name;
    };


    return (
        <>
            <div className="maltiple-assignment-view-popup-wrapper">
                <div className="maltiple-assignment-view-popup-container">
                    <div className="maltiple-assignment-view-popup-folder">
                        <div className="Back_button" onClick={startAssignmentPopupHandler}>
                            <i class="fa-solid fa-chevron-left"></i>
                            <span>Back to Assignments</span>
                        </div>
                        <div className="maltiple-assignment-view-popup-header">
                            <div className="maltiple-assignment-view-popup-title">
                                <h2>{type} {index + 1}: <span>{assignment?.name}</span></h2>
                                <p>{getAssignmentTypeName(assignment?.type)}</p>
                            </div>
                        </div>
                        <div className="maltiple-assignment-view-popup-details">
                            <MultipleAssignmentStaticContent courseType={courseType} assignment={assignment} />
                            <PreprocessAndRenderLatex
                                ref={null}
                                content={rubric?.rubric || ""}
                            />
                        </div>
                        <div className="maltiple-assignment-view-popup-time-folder">
                            <button onClick={startAssignmentHandler}>Proceed</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MultipleAssignmentviewPopup;